import { client } from './client';

export const userApi = {
  getProfileInfo: () => client.get('get_profile_info', { _noRedirect: true }),
  getEmployeeInfo: () => client.get('get_employee_info'),

  // Sends JSON {first_name, last_name, image_data}; backend parses via json.loads
  editProfileInfo: (data) => client.post('edit_profile_info', data),

  // Sends JSON {image_data, crop_point}; backend parses via json.loads
  cropImage: (data) => client.post('crop_image', data),

  sendSignature: (data) => client.post('send_signature', data),
  getSignature: () => client.get('get_signature'),

  // Email/phone endpoints
  getEmail: () => client.get('get_email'),
  getPhoneNumber: () => client.get('get_phone_number'),
  editEmail: (email) => client.get('edit_email', { params: { value: email } }),
  editPhoneNumber: (phone_number) => client.get('edit_phone_number', { params: { value: phone_number } }),

  getUserTicketCount: () => client.get('get_user_ticket_count'),
  getManagerTicketCount: () => client.get('get_manager_ticket_count'),
  getDispatcherTicketCount: () => client.get('get_dispatcher_ticket_count'),
  getManagerEmployeeTicketCount: () => client.get('get_manager_employee_ticket_count'),
  getSimpleEmployeeTicketCount: () => client.get('get_simple_employee_ticket_count'),

  getEmployeeList: () => client.get('get_employee_list'),
  getUserList: () => client.get('get_user_list'),
  getUserListView: () => client.get('get_user_list_view'),
  getEmployeeListView: () => client.get('get_employee_list_view'),
  // dispatcher/manager_user: add a plain employee to an existing department
  // (by department name) - distinct from add_department_employee, which is
  // manager_employee-only and always targets that manager's own department.
  addNewEmployeeToDepartment: (params) => client.get('add_new_employee_to_departmnt', { params }),
  updateEmployeeDepartment: (params) => client.get('update_employee_department', { params }),
  // get_user_list_view is dispatcher/manager_employee only - manager_user
  // needs this own-company-scoped variant instead.
  getCompanyUserList: () => client.get('get_company_user_list_view'),
  // GET (not POST): no file/image upload UI feeds these, so image_data is
  // always empty - avoids a CORS preflight instead of needing one to pass.
  addCompanyUser: (params) => client.get('add_company_user', { params }),
  addDepartmentEmployee: (params) => client.get('add_department_employee', { params }),
  getUsernamePrefixSettings: () => client.get('get_username_prefix_settings'),
  saveUsernamePrefixSettings: (data) => client.post('save_username_prefix_settings', data),
  getErrorAlertSettings: () => client.get('get_error_alert_settings'),
  saveErrorAlertSettings: (data) => client.post('save_error_alert_settings', data),

  // dispatcher/manager_employee acting on ANOTHER user's/employee's account
  // (as opposed to editPhoneNumber/changeUserActivation-style self-only or
  // already-scoped endpoints elsewhere).
  changeUserPassword: (params) => client.get('change_user_password', { params }),
  changeEmployeePassword: (params) => client.get('change_employee_password', { params }),
  changeMyPassword: (params) => client.get('change_my_password', { params }),
  adminEditPhoneNumber: (params) => client.get('admin_edit_phone_number', { params }),
  adminSendPhoneOtp: (params) => client.get('admin_send_phone_otp', { params }),
  adminVerifyPhoneOtp: (params) => client.get('admin_verify_phone_otp', { params }),
  changeUserActivation: (params) => client.get('change_user_activation', { params }),
  changeEmployeeActivation: (params) => client.get('change_emloyee_activation', { params }),
  editEmployeeInfo: (params) => client.get('edit_employee_info', { params }),
  editUserInfo: (params) => client.get('edit_user_info', { params }),
  deleteEmployee: (params) => client.get('delete_employee', { params }),

  // Saved sidebar menu order/hide state - see MenuOrderPage.jsx and
  // Sidebar.jsx's applyMenuPreferences (utils/menuPreferences.js)
  getMenuPreferences: () => client.get('get_menu_preferences'),
  // body: {items:[{main_menu_index,new_menu_index,hide}], num_of_tab?}
  saveMenuPreferences: (data) => client.post('save_menu_preferences', data),
};
